const validate = (values: any, props: any) => {
    const errors: {
        product:any;
    } = {
     product:undefined
    };
    if (!values.product) {
        errors.product = "Required";
      }
   
    return errors;
  };
  
  export default validate;
  